module.exports = __webpack_public_path__ + "img/arrow-up-white.80b723dc.svg";